import { useTranslation } from "react-i18next";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui";
import { SectionCard } from "@/components/common";

interface BookingSellerNotesSectionProps {
  notes: string | null | undefined;
  onEdit?: () => void;
  className?: string;
}

export function BookingSellerNotesSection({
  notes,
  onEdit,
  className,
}: BookingSellerNotesSectionProps) {
  const { t } = useTranslation("bookings");
  const trimmed = notes?.trim() ?? "";

  return (
    <SectionCard
      title={t("detail.sellerNotes")}
      icon={Pencil}
      className={className}
      action={
        onEdit ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-auto px-2 py-1 text-primary-700"
            leftIcon={<Pencil className="h-3.5 w-3.5" />}
            onClick={onEdit}
          >
            {trimmed ? t("sellerNotesModal.edit") : t("sellerNotesModal.add")}
          </Button>
        ) : null
      }
    >
      {trimmed ? (
        <p className="whitespace-pre-wrap text-sm text-surface-800">{trimmed}</p>
      ) : (
        <p className="text-sm text-surface-500">
          {t("sellerNotesModal.emptyDetail")}
        </p>
      )}
    </SectionCard>
  );
}
